// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Admin-infoGrid-___infoGrid__container___1G6OE","title-box":"src-components-Admin-infoGrid-___infoGrid__title-box___2zSIe","title":"src-components-Admin-infoGrid-___infoGrid__title___3Hl_P","button-box":"src-components-Admin-infoGrid-___infoGrid__button-box___1Su4n","client-box":"src-components-Admin-infoGrid-___infoGrid__client-box___1A2uc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/infoGrid/infoGrid.css
// module id = 1056
// module chunks = 0